module.exports = __webpack_public_path__ + "img/prize-02.602639c4.png";